var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefinition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2863 31.9887C52.2863 43.206 43.1952 52.306 31.9888 52.306C20.7825 52.306 11.6914 43.206 11.6914 31.9887C11.6914 20.7714 20.7825 11.6714 31.9888 11.6714C43.2177 11.6939 52.2863 20.7714 52.2863 31.9887Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0643 35.4801V29.2858L48.5511 28.8353C48.1686 26.808 47.426 24.916 46.3684 23.2041L50.0363 18.8568L45.6483 14.4645L41.4403 18.0459C39.7976 16.9197 37.9299 16.0863 35.9271 15.6132L35.4546 9.93701H29.2888L28.8388 15.4556C26.8135 15.8385 24.9008 16.5818 23.2131 17.6405L18.8476 13.9014L14.4821 18.2937L18.06 22.5058C16.9349 24.1501 16.1023 26.0197 15.6297 28.0244L9.93652 28.5199V34.7142L15.4497 35.1647C15.8322 37.1919 16.5748 39.084 17.6324 40.7959L13.9645 45.1432L18.3525 49.5355L22.5605 45.9541C24.2032 47.0803 26.071 47.9137 28.0737 48.3867L28.5462 54.063H34.7345L35.1845 48.5444C37.2098 48.1615 39.1225 47.4182 40.8102 46.3595L45.1532 50.031L49.5413 45.6387L45.9633 41.4266C47.0885 39.7823 47.9211 37.9127 48.3936 35.908L54.0643 35.4801Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8677 31.5832C41.8677 37.0342 37.4572 41.4715 31.989 41.4715C26.5209 41.4715 22.1104 37.0567 22.1104 31.5832C22.1104 26.1097 26.5209 21.6948 31.989 21.6948C37.4572 21.6948 41.8677 26.1322 41.8677 31.5832Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7324 31.5833C41.7324 36.9667 37.3669 41.3365 31.9888 41.3365C26.6106 41.3365 22.2451 36.9667 22.2451 31.5833C22.2451 26.1999 26.6106 21.8301 31.9888 21.8301",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.041 19.082L32.3939 22.4607L29.041 25.8169",
    stroke: "#0561FC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinition);
export default __webpack_public_path__ + "static/media/definition.6d11672f28a07156aed3d309baec1d44.svg";
export { ForwardRef as ReactComponent };